import HierarchyTree from "./HierarchyTree";

export default HierarchyTree;
